<template>
    <div class="h-full flex">
        <sidebar></sidebar>
        <main-container></main-container>
    </div>
</template>

<script>

import Sidebar from "./layout/Sidebar.vue";
import MainContainer from "./layout/MainContainer.vue";
import ResourcesService from "../../app/services/ResourcesService";
import ThemeUtil from "../../app/utils/ThemeUtil";

export default {
    name: 'StyleGuideApp',
    components: {MainContainer, Sidebar},
    data() {
        return {
            model: webase.model,
        }
    },
    mounted() {
        let resourcesService = new ResourcesService()
        let url = webase.utils.app.getBaseUrl() + '/resources/fonts.json?t=' + Date.now()
        resourcesService.get(url).then((response) => {
            this.model.fonts = response.items
        })

        this.model.styleGuide = ThemeUtil.newStyleGuide()
    },
    methods: {
        methodHere() {

        }
    }
}
</script>
